import * as React from 'react';
import { HrefLangsTagsProps } from './types';

export default function HrefLangsTags({ hrefLangs, hostname, path }: HrefLangsTagsProps): JSX.Element {
  return (
    <>
      <link data-testid="HrefLangsTags__Canonical" rel="canonical" href={`https://${hostname}${path}`} />
      {hrefLangs?.map(({ lang, href }) => (
        <link data-testid="HrefLangsTags__Alternate" key={lang} rel="alternate" href={href} hrefLang={lang} />
      ))}
    </>
  );
}
